export default __webpack_public_path__ + "static/media/the-island.1c95eec4.jpeg";